import React, { Fragment } from 'react';

// Importing SCSS files
import './adv.scss';
import {Button} from "@material-ui/core";
import { FiHeart, FiMessageCircle } from "react-icons/fi";


//Importing components

import AdvModalCreate from './AdvModalCreate';
import AdvModalUpdate from './AdvModalUpdate';
import {NavLink} from "react-router-dom";



const Adv = props => {

    const {
        usId,
        isAuth,
        onGetUsersList,
        onVisiblePopup,
        onHandleChangeFile,
        imgUrl,
        setImgUrl,
        progressBar,
        setProgressBar,
        addAdv,
        onDeleteUser,
        userId,
        item,
        updateAdv,
        onHandleCreateUserForm,
        advInfo,
        visiblePopup
    } = props;

    return(
        <Fragment>
            {visiblePopup.modalWarning &&
                <div>
                    <div className="modal__created-blur"></div>
                    <div className="modal__created-modal-warning">
                        <div className="created__modal-header">
                            <h2>Внимание!</h2>
                        </div>

                        <div className="created__modal-body">
                            <p>Вы уверены, что хотите удалить пользователя? Это действие необратимо!</p>
                        </div>

                        <div className="created__modal-bottom">
                            <button type="button" className="close__button" onClick={() => onVisiblePopup("modalWarning")}>Закрыть</button>
                            <button type="button" className="delete__button" onClick={() => onDeleteUser(true, userId)}>Удалить</button>
                        </div>
                    </div>
                </div>
            }

            { visiblePopup.modalUpdate && <AdvModalUpdate
                onHandleChangeFile={onHandleChangeFile}
                item={item}
                updateAdv={updateAdv}
                onVisiblePopup={onVisiblePopup}
                imgUrl={imgUrl}
            /> }



            { visiblePopup.modalUsers && <AdvModalCreate
                usId={usId}
                onHandleChangeFile={onHandleChangeFile}
                imgUrl={imgUrl}
                setImgUrl={setImgUrl}
                progressBar={progressBar}
                setProgressBar={setProgressBar}
                addAdv={addAdv}
                onVisiblePopup={onVisiblePopup}
                onHandleCreateUserForm={onHandleCreateUserForm}
                advInfo={advInfo}
            /> }



            <div className="users">
                <div className="users__filter-panel">
                    <div><h2>Продажа</h2></div>
                    {
                        (isAuth)
                    ?
                    <div className="users__filter-panel__right__part">
                        <div className="itemIcon"><NavLink to='/favorites' ><span><FiHeart/></span></NavLink></div>
                        <div className="itemIcon"><NavLink to='/dialogs' ><span><FiMessageCircle/></span></NavLink></div>

                        {/*<NavLink to={'/razmestit-obyavlenie'}>*/}
                        <div className="itemButton">
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    onVisiblePopup("modalUsers")
                                }}
                            >Новое объявление
                            </Button>
                        </div>
                        {/*</NavLink>*/}
                    </div>
                    : null
                    }
                </div>

                <div className="users__card-wrapper">
                    {onGetUsersList()}
                </div>

            </div>
        </Fragment>
    );
};

export default Adv;